<template>
  <v-container class="pa-6">
    <div>
      <span class="main-title">
        Oi {{ result.name }}! <br />
        De acordo com as suas informações, <br />
        preparamos estas opções personalizadas!
      </span>
    </div>

    <div class="d-flex flex-column justify-center align-center mt-4 mb-6">
      <span class="info-label">Clique ou passse o mouse para ver detalhes</span>
      <div class="top-card pa-2">
        <div
          class="d-flex justify-space-around align-center flex-column text-center"
          style="width: 50%"
        >
          <strong class="top-card-title">
            Seus beneficiários receberão indenização
          </strong>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span class="top-card-label" v-bind="attrs" v-on="on"
                >Falecimento Qualquer Causa</span
              >
            </template>
            <span
              >Indenização única aos <br />
              beneficiários em caso de <br />
              falecimento por qualquer <br />
              causa do segurado
            </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span class="top-card-label" v-bind="attrs" v-on="on"
                >Falecimento Acidental
              </span>
            </template>
            <span
              >Indenização única aos <br />
              beneficiários em caso de <br />
              falecimento apenas por <br />
              acidente do segurado
            </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span class="top-card-label" v-bind="attrs" v-on="on"
                >Serviço de assistência Funeral
              </span>
            </template>
            <span
              >Reembolso aos <br />
              beneficiários das despesas <br />
              efetivas gastas no <br />
              funeral do segurado
            </span>
          </v-tooltip>
        </div>

        <v-divider class="mx-2" vertical> </v-divider>

        <div
          class="d-flex justify-space-around align-center flex-column text-center"
          style="width: 50%"
        >
          <strong class="top-card-title"
            >Você recebe a <br />
            indenização</strong
          >

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span class="top-card-label" v-bind="attrs" v-on="on">
                Invalidez Permanente Total ou parcial por acidente
              </span>
            </template>
            <span
              >Indenização única ao próprio <br />
              segurado, relativa à perda, <br />
              redução ou impotência funcional <br />
              definitiva, total ou parcial, <br />
              de um membro ou órgão em virtude <br />
              de lesão física causada por acidente pessoal
            </span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span class="top-card-label" v-bind="attrs" v-on="on"
                >Indenização especial de invalidez por Doença
              </span>
            </template>
            <span
              >Indenização ao próprio <br />
              segurado em consequência de <br />
              doença que cause perda de sua <br />
              existência independente
            </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span class="top-card-label" v-bind="attrs" v-on="on">
                Doenças graves
              </span>
            </template>
            <span>
              Indenização ao próprio <br />
              segurado após sobrevivência <br />
              de 30 dias ao diganóstico das <br />
              seguintes doenças: Câncer, Infarto <br />
              agudo do miocárdio, AVC, <br />
              Insuficiência renal terminal, <br />
              transplante de órgãos (coração, <br />
              pulmão, fígado, pâncreas, rim, <br />
              intestino delgado ou medula óssea)
            </span>
          </v-tooltip>
        </div>
      </div>
    </div>

    <span class="main-subtitle">Selecione uma das opções:</span>
    <br />
    <span class="info-label">
      Você pode modificar os valores segurados das coberturas <br />
      e ver em tempo real a estimativa de custo mensal.
    </span>

    <Option
      :result="result"
      :number="1"
      :haveImage="true"
      @selectItem="select"
      :socio="socio"
    />
    <Option
      :result="result"
      :number="2"
      :haveImage="true"
      :socio="socio"
      @selectItem="select"
    />
  </v-container>
</template>

<style scoped>
.main-title {
  font-size: 31px;
  line-height: 36px;
  letter-spacing: 0.15px;
  color: #39424e;
  display: flex;
  justify-content: center;
}

.top-card {
  display: flex;
  background: #ffffff;
  border: 1px solid #00c7ba;
  box-sizing: border-box;
  border-radius: 6px;
}

.top-card-title {
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #39424e;
}

.top-card-label {
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.15px;
  color: #00c7ba;
}

.info-label {
  font-weight: normal;
  font-size: 14px;
  line-height: 25px;
  letter-spacing: 0.15px;
  color: #b9b9b9;
}

.main-subtitle {
  font-weight: normal;
  font-size: 24px;
  line-height: 36px;
  letter-spacing: 0.15px;
  color: #39424e;
}
</style>

<script>
import Option from "./option.vue";

export default {
  name: "Results",

  props: {
    result: Object,
    socio: Object,
  },

  data: () => ({
    covers: null,
  }),

  components: {
    Option,
  },

  methods: {
    select(item) {
      this.$emit("selectItem", item);
    },
  },
};
</script>
